import { cn } from '../../lib/cn';
import type { MarketplaceSpec } from '../../marketconnect/framework';

type Props = {
  marketplaces: MarketplaceSpec[];
};

function healthColor(score: number): string {
  if (score >= 90) return 'text-success-600 dark:text-success-400';
  if (score >= 80) return 'text-brand-600 dark:text-brand-400';
  return 'text-warning-600 dark:text-warning-400';
}

export function MarketplaceGrid({ marketplaces }: Props) {
  const regions = ['north_america', 'europe', 'far_east'] as const;
  const regionLabels: Record<string, string> = {
    north_america: 'North America',
    europe: 'Europe',
    far_east: 'Far East',
  };

  return (
    <div className="space-y-4">
      {regions.map((region) => {
        const mpks = marketplaces.filter((m) => m.region === region);
        if (mpks.length === 0) return null;
        return (
          <div key={region}>
            <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">{regionLabels[region]}</p>
            <div className="mt-2 grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
              {mpks.map((m) => (
                <div
                  key={m.id}
                  className={cn(
                    'rounded-lg border p-3',
                    m.enabled
                      ? 'border-orange-200 bg-orange-50/50 dark:border-orange-900 dark:bg-orange-950/30'
                      : 'border-slate-200 dark:border-slate-700',
                  )}
                >
                  <div className="flex items-center justify-between">
                    <p className="text-sm font-medium text-slate-900 dark:text-slate-100">{m.name}</p>
                    <span className={cn('text-sm font-semibold', healthColor(m.health))}>{m.health}</span>
                  </div>
                  <p className="mt-1 text-xs text-slate-500">{m.country} · {m.enabled ? 'Connected' : 'Available'}</p>
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}
